import getApiClient from '../../../../plugins/api'

export default function() {
    const self = this

    if (self.$store.state.user.roles) {
        self.checkAccess()
    }

    self.$root.$on('sessionChecked', () => {
        self.checkAccess()
    })

    // Pre-populate trip filter from URL query param
    if (self.$route.query.trip) {
        const tripId = self.$route.query.trip
        self.searchParams['trip.id'] = tripId
        self.searchParams.futureTrips = false
        self.searchParams.pastTrips = false

        const api = getApiClient(self.$root.$store)
        api.get(`trips/${tripId}`)
            .then(result => {
                self.tripInitialValue = tripId
                self.tripInitialDisplay = result.data.eventTitle
            })
            .catch(() => {
                self.tripInitialValue = tripId
                self.tripInitialDisplay = `#${tripId}`
            })
    }

    self.loadOrders()

    // Default value in the filter list
    self.searchParams.status = [3, 8, 4, 6];
}
